export default __webpack_public_path__ + "static/media/Block_24.e2ef2281.svg";